export const SHOW_LOADER = 'SHOW_LOADER';
export const SHOW_CUSTOM_LOADER = 'SHOW_CUSTOM_LOADER';
export const REMOVE_LOADER = 'HIDE_LOADER';
